module.exports = __webpack_public_path__ + "static/media/banner2.f556f4ab.png";